import trpc from "../utils/trpc";
import { Button } from "../components/button/button";
import { FillContainerLoader } from "../components/loader";

function CourseNotInitializedView() {
  const { data: sessionData, isLoading } = trpc.session.get.useQuery(undefined, { staleTime: Infinity });
  const isAdmin = !!sessionData?.userInfo.roles.includes(
    "http://purl.imsglobal.org/vocab/lis/v2/institution/person#Administrator",
  );
  const utils = trpc.useUtils();
  const initCourse = trpc.course.init.useMutation({
    onSuccess: () => {
      // Invalidate status so router gate re-runs and loads course UI
      utils.course.status.invalidate();
    },
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-ecru px-6 py-12 text-center">
      <div className="max-w-xl space-y-4">
        <h1 className="text-3xl font-semibold text-midnight">Course Not Initialized</h1>
        {isLoading && (
          <div className="h-56">
            <FillContainerLoader delayMs={0} size="large" />
          </div>
        )}
        {isAdmin ? (
          <div className="space-y-3">
            <p className="text-midnight/70">As an administrator you can initialize this course now.</p>
            <Button
              filled="sunburst"
              className="mx-auto px-6 py-3 text-base"
              loading={initCourse.isPending}
              disabled={initCourse.isPending || initCourse.isSuccess}
              onClick={() => initCourse.mutate()}>
              {initCourse.isSuccess ? "Initialized" : "Initialize Course"}
            </Button>
            {initCourse.isError && (
              <p className="text-sm text-error">Initialization failed: {initCourse.error?.message}</p>
            )}
            {initCourse.isSuccess && <p className="text-sm text-lac-leman">Initialization complete.</p>}
          </div>
        ) : (
          <p className="text-midnight/70">Please contact a course administrator to initialize the course.</p>
        )}
      </div>
    </div>
  );
}

export { CourseNotInitializedView as Component };
